import { render } from "./TransactionNumberInput.vue?vue&type=template&id=98d0f056&ts=true"
import script from "./TransactionNumberInput.vue?vue&type=script&lang=ts"
export * from "./TransactionNumberInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__